
import {normalizeSkills, normalizeSources} from '../chat-input-defs.js'
import CommandsMobile from './commands-mobile.vue'
import CommandsDesktop from './commands-desktop.vue'

export default {
  components: {CommandsDesktop, CommandsMobile},
  inject: ['di_caps'],
  emits: ['source', 'skill'],
  computed: {
    skills() {
      return normalizeSkills(this.di_caps?.skills)
    },
    sources() {
      return normalizeSources(this.di_caps?.sources || [])
        .filter(source => source.command !== '@files' || this.$global.fileUploadEnabled)
    }
  }
}
